import { USER_JURISDICTION_QUERY, USER_COUNTRY_QUERY, COUNTRY_JURISDICTION_QUERY, USER_COUNTRY_UPDATED, USER_JURISDICTION_UPDATED } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { JurisdictionCommonService } from './jurisdiction.utils.js';

var JurisdictionService = /** @class */ (function () {
    function JurisdictionService(countryToJurisdiction, defaultJurisdiction) {
        this.service = new JurisdictionCommonService(countryToJurisdiction, defaultJurisdiction);
        this.registerJurisdictionEvents();
        this.registerJurisdictionQuery();
        this.registerJurisdictionChanges();
    }
    JurisdictionService.prototype.registerJurisdictionQuery = function () {
        var _this = this;
        window.queryBus.subscribe(USER_JURISDICTION_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            var country;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_COUNTRY_QUERY)];
                    case 1:
                        country = _a.sent();
                        return [2 /*return*/, this.service.getJurisdictionByCountry(country)];
                }
            });
        }); });
        window.queryBus.subscribe(COUNTRY_JURISDICTION_QUERY, function (event) {
            var country = event.payload;
            return _this.service.getJurisdictionByCountry(country);
        });
    };
    JurisdictionService.prototype.registerJurisdictionChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_COUNTRY_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var country, jurisdiction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        country = event.payload;
                        return [4 /*yield*/, this.service.getJurisdictionByCountry(country)];
                    case 1:
                        jurisdiction = _a.sent();
                        window.eventBus.publish(USER_JURISDICTION_UPDATED, jurisdiction);
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    JurisdictionService.prototype.registerJurisdictionEvents = function () {
        window.eventBus.register(USER_JURISDICTION_UPDATED, {
            type: 'string',
            enum: Object.values(Jurisdiction),
        });
    };
    return JurisdictionService;
}());

export { JurisdictionService };
